import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReservationStoreEffects } from './reservation-store.effects';
import { reducer, reservationStoreFeatureKey } from './reservation-store.reducers';

export function provideReservationStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(reservationStoreFeatureKey, reducer),
    provideEffects([ReservationStoreEffects]),
  ]);
}
